export enum ROUTE_PATHS {
  login = '/login',
  wallets = '/wallets',
  accounts = '/accounts',
  reports = '/reports',
  bridge = '/bridge',
  mexcDistributor = '/mexc-distributor',
  publicCexMarket = '/public-market/:cex/:base/:quote',
  publicClobMarket = '/public-clob/:venue/:market',
  publicDexPool = '/public-dex/:dex/:pool',
  publicDexAggregator = '/public-aggregator/:aggregator/:market',
  publicStableSwapPool = '/public-stableswap/:venue/:pool',
  publicSingletonPool = '/public-singleton/:venue/:pool',
  publicConcentratedPool = '/public-concentrated/:venue/:pool',
  publicAvalanchePool = '/public-avalanche/:venue/:pool',
  publicSuiPool = '/public-sui/:venue/:pool',
  publicTonPool = '/public-ton/:venue/:pool',
  publicTronPool = '/public-tron/:venue/:pool',
  publicNearPool = '/public-near/:venue/:pool',
  publicAptosPool = '/public-aptos/:venue/:pool',
  project = '/project/:id',
  pair = '/project/:projectId/:venue/:pairId',
  dexPair = '/project/:projectId/dex-pair/:pairId',
  cexPair = '/project/:projectId/cex-pair/:pairId',
  solPair = '/project/:projectId/sol-pair/:pairId',
  arbitrage = '/project/:projectId/arbitrage/:arbitrageId',
  balancer = '/project/:projectId/balancer/:balancerId',
  balancerCreate = '/project/:projectId/balancer/create',
}
